// packages/ui-kit/src/primitives/EmptyState.tsx
// C3F v18 — reference: design/system/components/core/EmptyState.{jsx,prompt.md}
// Empty state on a dashed hairline: says what is missing and what to DO,
// never "Nessun risultato" — copy is a concrete scene.
import { type ReactNode } from "react";

type Size = "compact" | "default" | "large";

interface Props {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  size?: Size;
  className?: string;
}

// DS padding is 56px/24px; `compact` (list-level empties) and `large` keep the
// same anatomy and only scale the breathing room + title step.
const sizeCls: Record<Size, { wrap: string; title: string }> = {
  compact: { wrap: "px-6 py-8", title: "text-base" },
  default: { wrap: "px-6 py-14", title: "text-h4" },
  large: { wrap: "px-6 py-20", title: "text-h4" },
};

export function EmptyState({
  icon,
  title,
  description,
  action,
  size = "default",
  className = "",
}: Props) {
  const s = sizeCls[size];
  return (
    <div
      className={`grid justify-items-center gap-3 rounded-lg border border-dashed border-border-default bg-subtle text-center ${s.wrap} ${className}`}
    >
      {icon && <div className="mb-1 text-fg-subtle">{icon}</div>}
      <div className={`${s.title} font-semibold text-fg-default`}>{title}</div>
      {description && <p className="max-w-[44ch] text-sm text-fg-muted">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
